import React from 'react';
import styled from 'styled-components';

import { CustomRow } from 'src/presentation/components/forms/CustomRow';
import { FIELD_MAPPER } from 'src/presentation/components/pages/threads/ThreadsConstants';
import {
  FirstColumn,
  SecondColumn,
  StyledInputField,
  ThreadInCardMessagesImage,
  ThreadOrderStatusImage,
  ThreadResolutionImage,
  ThreadSection,
} from 'src/presentation/components/pages/threads/ThreadsLayouts';
import TextareaField from 'src/presentation/components/forms/TextareaField';

const OrderStatusSection = () => (
  <>
    <FirstColumn>
      <ThreadSection
        header="Order Status"
        description="Order-related messages sent to the customer upon email authentication."
      >
        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.ORDERS_FOUND.label}
            description={FIELD_MAPPER.ORDERS_FOUND.description}
            data-aid={FIELD_MAPPER.ORDERS_FOUND.path}
            attr={FIELD_MAPPER.ORDERS_FOUND.path}
            placeholder={FIELD_MAPPER.ORDERS_FOUND.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.NO_ORDERS_FOUND.label}
            description={FIELD_MAPPER.NO_ORDERS_FOUND.description}
            data-aid={FIELD_MAPPER.NO_ORDERS_FOUND.path}
            attr={FIELD_MAPPER.NO_ORDERS_FOUND.path}
            placeholder={FIELD_MAPPER.NO_ORDERS_FOUND.placeholder}
          />
        </CustomRow>

        <MissingFulfillmentRow>
          <TextareaField
            label={FIELD_MAPPER.MISSING_FULFILLMENT_MESSAGE.label}
            description={FIELD_MAPPER.MISSING_FULFILLMENT_MESSAGE.description}
            data-aid={FIELD_MAPPER.MISSING_FULFILLMENT_MESSAGE.path}
            attr={FIELD_MAPPER.MISSING_FULFILLMENT_MESSAGE.path}
            placeholder={FIELD_MAPPER.MISSING_FULFILLMENT_MESSAGE.placeholder}
          />
        </MissingFulfillmentRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.MISSING_STATUS_AND_ETA_MESSAGE.label}
            description={FIELD_MAPPER.MISSING_STATUS_AND_ETA_MESSAGE.description}
            data-aid={FIELD_MAPPER.MISSING_STATUS_AND_ETA_MESSAGE.path}
            attr={FIELD_MAPPER.MISSING_STATUS_AND_ETA_MESSAGE.path}
            placeholder={FIELD_MAPPER.MISSING_STATUS_AND_ETA_MESSAGE.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.MISSING_ETA_MESSAGE.label}
            description={FIELD_MAPPER.MISSING_ETA_MESSAGE.description}
            data-aid={FIELD_MAPPER.MISSING_ETA_MESSAGE.path}
            attr={FIELD_MAPPER.MISSING_ETA_MESSAGE.path}
            placeholder={FIELD_MAPPER.MISSING_ETA_MESSAGE.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.VERIFY_SUCCESS.label}
            description={FIELD_MAPPER.VERIFY_SUCCESS.description}
            data-aid={FIELD_MAPPER.VERIFY_SUCCESS.path}
            attr={FIELD_MAPPER.VERIFY_SUCCESS.path}
            placeholder={FIELD_MAPPER.VERIFY_SUCCESS.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <StyledInputField
            label={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_YES_THATS_HELPED.label}
            description={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_YES_THATS_HELPED.description}
            data-aid={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_YES_THATS_HELPED.path}
            attr={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_YES_THATS_HELPED.path}
          />
        </CustomRow>

        <CustomRow>
          <StyledInputField
            label={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_TO_HERO.label}
            description={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_TO_HERO.description}
            data-aid={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_TO_HERO.path}
            attr={FIELD_MAPPER.ORDER_STATUS_HAS_BEEN_SHOWN_QUICK_REPLY_TO_HERO.path}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED.label}
            description={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED.description}
            data-aid={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED.path}
            attr={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED.path}
            placeholder={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <StyledInputField
            label={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_GOODBY.label}
            description={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_GOODBY.description}
            data-aid={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_GOODBY.path}
            attr={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_GOODBY.path}
          />
        </CustomRow>

        <CustomRow>
          <StyledInputField
            label={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_TO_HERO.label}
            description={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_TO_HERO.description}
            data-aid={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_TO_HERO.path}
            attr={FIELD_MAPPER.ASK_THERE_ANYTHING_ELSE_YOU_NEED_QUICK_REPLY_TO_HERO.path}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_END.label}
            description={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_END.description}
            data-aid={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_END.path}
            attr={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_END.path}
            placeholder={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_END.placeholder}
          />
        </CustomRow>

        <CustomRow>
          <TextareaField
            label={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_HERO.label}
            description={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_HERO.description}
            data-aid={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_HERO.path}
            attr={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_HERO.path}
            placeholder={FIELD_MAPPER.CUSTOMER_HAS_OPTED_TO_HERO.placeholder}
          />
        </CustomRow>
      </ThreadSection>
    </FirstColumn>
    <SecondColumn>
      <ThreadOrderStatusImage />
      <ThreadInCardMessagesImage />
      <ThreadResolutionImage />
    </SecondColumn>
  </>
);

const MissingFulfillmentRow = styled(CustomRow)`
  margin-top: 200px;
`;

export default OrderStatusSection;
